import _ from 'lodash'
import React from 'react'
import useSearchParams from '@vero/ui-core-browser/hooks/search-params.js'

export default function ({ providers }) {
  const { searchParams } = useSearchParams()

  function buildSsoUri (provider) {
    const state = btoa(JSON.stringify(searchParams))
    return `/api/auth/sso?identity_provider=${provider}&redirect_uri=${window.location.origin}/sso&state=${state}`
  }

  return _.chain(providers).without('email').map(provider => (
    <a
      key={provider}
      className='btn btn-primary btn-outline'
      href={buildSsoUri(provider)}
    >
      Sign In with {provider}
    </a>
  )).value()
}
